import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@reg/shared/shared.module';
import { ErrorPageComponent } from '@reg/error-page/error-page.component';
import { ErrorPageRoutingModule } from '@reg/error-page/error-page-routing.module';

@NgModule({
    declarations: [
        ErrorPageComponent,
    ],
    exports: [
        ErrorPageComponent,
    ],
    imports: [
        CommonModule,
        ErrorPageRoutingModule,
        SharedModule,
    ],
})
export class ErrorPageModule {
}
